import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Button from "../../../componentLibrary/Button";

interface UnsupportedComponentsSaveModalProps {
  isOpen: boolean;
  onSaveAsIs: () => void;
  onDeleteAndSave: () => void;
  onCancel: () => void;
}

const UnsupportedComponentsSaveModal: React.FC<
  UnsupportedComponentsSaveModalProps
> = ({ isOpen, onSaveAsIs, onDeleteAndSave, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-gray-800 bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Unsupported components</h3>
          <button
            onClick={onCancel}
            className="text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <p className="mb-4 text-gray-700">
          This section contains unsupported components on one or more pages.
        </p>
        <div className="flex flex-col gap-2">
          <Button variant="primary" className="w-full" onClick={onSaveAsIs}>
            Save these as-is
          </Button>
          <Button
            variant="secondary"
            className="w-full"
            onClick={onDeleteAndSave}
          >
            Delete these and save section
          </Button>
          <Button variant="alternative" className="w-full" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnsupportedComponentsSaveModal;
